/**
 * Products Domain - Arabic Translations
 * Flat structure (no nested 'products' wrapper) - namespace added by portal
 */

export const arTranslations = {
  title: 'المنتجات',
  subtitle: 'إدارة وحدات SKU والمتغيرات والفئات',
  // Unit labels (flat keys for UI components)
  packaging: {
    bags: 'أكياس',
    bulk: 'سائب',
  },
  bag: 'كيس',
  bags: 'أكياس',
  bulk: 'سائب',
  ton: 'طن',
  tons: 'طن',
  perBag: 'للكيس',
  perTon: 'للطن',
  addItem: 'إضافة عنصر',
  addSku: 'إضافة SKU',
  editSku: 'تعديل SKU',
  addVariant: 'إضافة متغير',
  editVariant: 'تعديل متغير',
  addCategory: 'إضافة فئة',
  editCategory: 'تعديل فئة',
  skuDetails: 'تفاصيل SKU',
  variantDetails: 'تفاصيل المتغير',
  noSkus: 'لا توجد وحدات SKU',
  noVariants: 'لا توجد متغيرات',
  noCategories: 'لا توجد فئات',
  searchPlaceholder: 'البحث في المنتجات...',
  overview: 'نظرة عامة',

  // Timeline
  timelineTab: 'السجل الزمني',
  timelineEmpty: 'لا توجد أحداث بعد',
  timelineEmptyDesc: 'ستظهر هنا التغييرات على هذا المتغير وSKU الخاص به والفئات',
  selectVariant: 'اختر متغيراً',

  // Stats
  stats: {
    totalSkus: 'إجمالي SKUs',
    activeSkus: 'SKUs نشطة',
    totalVariants: 'إجمالي المتغيرات',
    activeVariants: 'متغيرات نشطة',
    totalCategories: 'الفئات',
  },

  // Form fields
  form: {
    name: 'الاسم',
    nameEn: 'الاسم (إنجليزي)',
    nameAr: 'الاسم (عربي)',
    description: 'الوصف',
    descriptionEn: 'الوصف (إنجليزي)',
    descriptionAr: 'الوصف (عربي)',
    categories: 'الفئات',
    selectCategories: 'اختر الفئات',
    sku: 'SKU',
    selectSku: 'اختر SKU',
    variantCode: 'رمز المتغير',
    variantCodePlaceholder: 'مثال: VAR-001',
    barcode: 'الباركود',
    weight: 'الوزن (كجم)',
    packaging: 'نوع التغليف',
    portalAvailability: 'متاح في',
    deliveryGrouping: 'قاعدة تجميع التوصيل',
    isActive: 'نشط',
    sapIntegration: 'تكامل SAP',
    sapMaterialCode: 'رمز المادة SAP',
    sapMaterialCodePlaceholder: 'مثال: 000000000050000010',
    sapStorageLocationCode: 'رمز موقع التخزين SAP',
    sapStorageLocationCodePlaceholder: 'مثال: Z017',
    sapDescription: 'وصف SAP',
    sapBaseUnit: 'وحدة القياس الأساسية SAP',
    code: 'الرمز',
    codePlaceholder: 'مثال: CAT-001',
    color: 'اللون',
    parentCategory: 'الفئة الأم',
    noParent: 'بدون فئة أم (مستوى أعلى)',
  },

  portalAvailability: {
    ecommerce: 'التجارة الإلكترونية',
    portal: 'البوابة',
    both: 'كلاهما',
  },

  // Packaging types (nested for form select options)
  packagingTypes: {
    bags: 'أكياس',
    bulk: 'سائب',
  },

  // Delivery grouping rules
  deliveryGrouping: {
    allowMixed: 'السماح بالخلط',
    allowMixedDesc: 'يمكن توصيله مع أنواع تغليف أخرى',
    requireSame: 'يتطلب نفس النوع',
    requireSameDesc: 'يجب توصيله مع نفس نوع التغليف فقط',
  },

  // Validation messages
  validation: {
    nameRequired: 'الاسم مطلوب',
    codeRequired: 'رمز المتغير مطلوب',
    barcodeRequired: 'الباركود مطلوب',
    weightRequired: 'الوزن مطلوب',
    weightMin: 'يجب أن يكون الوزن 1 كجم على الأقل',
    skuRequired: 'SKU مطلوب',
    packagingRequired: 'نوع التغليف مطلوب',
  },

  // Delete confirmations
  delete: {
    confirmSku: 'هل أنت متأكد من حذف هذا الـ SKU؟',
    confirmVariant: 'هل أنت متأكد من حذف هذا المتغير؟',
    warning: 'لا يمكن التراجع عن هذا الإجراء. سيتم أيضاً إزالة جميع المتغيرات المرتبطة.',
    variantWarning: 'لا يمكن التراجع عن هذا الإجراء. سيتم إزالة المتغير من جميع مصفوفات التوفر.',
  },

  // Success messages
  success: {
    skuCreated: 'تم إنشاء SKU بنجاح',
    skuUpdated: 'تم تحديث SKU بنجاح',
    skuDeleted: 'تم حذف SKU بنجاح',
    variantCreated: 'تم إنشاء المتغير بنجاح',
    variantUpdated: 'تم تحديث المتغير بنجاح',
    variantDeleted: 'تم حذف المتغير بنجاح',
    categoryCreated: 'تم إنشاء الفئة بنجاح',
    categoryUpdated: 'تم تحديث الفئة بنجاح',
  },

  // Error messages
  error: {
    fetchFailed: 'فشل في جلب المنتجات',
    createFailed: 'فشل في إنشاء المنتج',
    updateFailed: 'فشل في تحديث المنتج',
    deleteFailed: 'فشل في حذف المنتج',
  },

  // Filters
  filter: {
    all: 'الكل',
    active: 'نشط',
    inactive: 'غير نشط',
    allPackaging: 'جميع أنواع التغليف',
    allCategories: 'جميع الفئات',
  },

  // Certificates section
  certificates: {
    title: 'الشهادات',
    refresh: 'تحديث',
    addCertificate: 'إضافة شهادة',
    searchPlaceholder: 'البحث في الشهادات...',
    typeFilter: 'النوع',
    allTypes: 'جميع الأنواع',
    typeGeneral: 'عام',
    typeVariant: 'متغير',
    allStatuses: 'جميع الحالات',
    statusActive: 'نشط',
    statusInactive: 'غير نشط',
    colTitle: 'العنوان',
    colType: 'النوع',
    colLinkedVariant: 'المتغير المرتبط',
    colFile: 'الملف',
    colStatus: 'الحالة',
    colActions: 'الإجراءات',
    noCertificates: 'لا توجد شهادات',
    addFirstCertificate: 'أضف شهادتك الأولى',
    typeGeneralLabel: 'عام',
    typeVariantLabel: 'متغير',
    typeUnlinkedLabel: 'غير مرتبط',
    noFile: 'لا يوجد ملف',
    deleteConfirm: 'حذف "$1"؟',
    editCertificate: 'تعديل الشهادة',
    fieldTitle: 'العنوان',
    titlePlaceholder: 'مثال: ISO 9001:2015',
    titleRequired: 'العنوان مطلوب',
    fieldDescription: 'الوصف',
    descriptionPlaceholder: 'وصف اختياري',
    fieldGeneralCert: 'شهادة عامة',
    generalCertHint: 'تظهر في صفحة "عن الشركة"',
    fieldActive: 'نشط',
    activeHint: 'مرئي للعملاء',
    fieldLinkedVariant: 'المتغير المرتبط',
    selectVariantOptional: 'اختر متغيراً (اختياري)',
    fieldPdf: 'ملف PDF للشهادة',
    uploadPdf: 'انقر لرفع PDF',
    onlyPdfAccepted: 'ملفات PDF فقط مقبولة',
    uploadFailed: 'فشل رفع الملف. يرجى المحاولة مرة أخرى.',
    cancel: 'إلغاء',
    saveChanges: 'حفظ التغييرات',
    createCertificate: 'إنشاء شهادة',
  },

  // Table headers
  table: {
    name: 'الاسم',
    code: 'الرمز',
    barcode: 'الباركود',
    weight: 'الوزن',
    packaging: 'التغليف',
    status: 'الحالة',
    variants: 'المتغيرات',
    categories: 'الفئات',
    actions: 'الإجراءات',
    color: 'اللون',
    parent: 'الفئة الأم',
    skus: 'وحدات SKU',
  },
}

export type ProductsTranslationsAr = typeof arTranslations
